{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Sélectionner un élément",
  "tableResizer": "Redimensionneur",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
